import supabase from "../../supabaseClient/supabaseClient";

// Where the sign-up confirmation email sends the teacher. This URL must be listed in
// Supabase → Authentication → URL Configuration → Redirect URLs.
export const EMAIL_CONFIRMED_PATH = "/auth/confirmed";
export const EMAIL_CONFIRMED_REDIRECT_URL = `https://app.theworksheep.com${EMAIL_CONFIRMED_PATH}`;

const PENDING_EMAIL_KEY = "worksheep:pendingSignupEmail";

// Supabase (implicit flow) puts tokens or errors in the URL hash, and sometimes errors in the query.
export const readAuthCallbackParams = ({ hash = "", search = "" } = {}) => {
  const params = {};
  new URLSearchParams(search).forEach((value, key) => {
    params[key] = value;
  });
  new URLSearchParams(hash.replace(/^#/, "")).forEach((value, key) => {
    params[key] = value;
  });
  return params;
};

// True when the URL carries the result of clicking a sign-up confirmation link.
export const isEmailConfirmationCallback = (location) => {
  const params = readAuthCallbackParams(location);
  if (params.type === "recovery") return false;
  return Boolean(
    params.access_token || params.code || params.error || params.error_code || params.error_description
  );
};

export const rememberPendingSignupEmail = (email) => {
  try {
    localStorage.setItem(PENDING_EMAIL_KEY, email);
  } catch {
    // Storage can be unavailable (private mode); the confirm page then asks for the email.
  }
};

export const getPendingSignupEmail = () => {
  try {
    return localStorage.getItem(PENDING_EMAIL_KEY) || "";
  } catch {
    return "";
  }
};

export const clearPendingSignupEmail = () => {
  try {
    localStorage.removeItem(PENDING_EMAIL_KEY);
  } catch {
    // Nothing to clear.
  }
};

export const resendConfirmationEmail = (email) =>
  supabase.auth.resend({
    type: "signup",
    email,
    options: { emailRedirectTo: EMAIL_CONFIRMED_REDIRECT_URL },
  });
